import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/v1`;
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

const BIZ_KEY = "clockaroo.business";
export const getBusinessId = () => localStorage.getItem(BIZ_KEY);
export const setStoredBusinessId = (id) => (id ? localStorage.setItem(BIZ_KEY, id) : localStorage.removeItem(BIZ_KEY));

api.interceptors.request.use((cfg) => {
  const b = getBusinessId();
  if (b && !cfg.headers["X-Business-Id"]) cfg.headers["X-Business-Id"] = b;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    const skip = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/logout"].some((p) => cfg?.url?.includes(p));
    if (err.response?.status === 401 && cfg && !cfg._retry && !skip) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function formatError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d && typeof d.msg === "string" ? d.msg.replace(/^Value error, /, "") : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
